"use strict";
/**
 * @module LRUCache
 */

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator/index.js");

var _classPrivateFieldSet = require("/vercel/path0/node_modules/@babel/runtime/helpers/classPrivateFieldSet.js");

var _classPrivateFieldGet = require("/vercel/path0/node_modules/@babel/runtime/helpers/classPrivateFieldGet.js");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

var _Symbol$iterator;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(_indexes2),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(_rindexes2);

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) { _classCheckPrivateStaticAccess(receiver, classConstructor); _classCheckPrivateStaticFieldDescriptor(descriptor, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) { _classCheckPrivateStaticAccess(receiver, classConstructor); _classCheckPrivateStaticFieldDescriptor(descriptor, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classCheckPrivateStaticFieldDescriptor(descriptor, action) { if (descriptor === undefined) { throw new TypeError("attempted to " + action + " private static field before its declaration"); } }

function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/esnext.global-this.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LRUCache = void 0;
var perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var warned = new Set();
/* c8 ignore start */

var PROCESS = typeof process === 'object' && !!process ? process : {};
/* c8 ignore start */

var emitWarning = function emitWarning(msg, type, code, fn) {
  typeof PROCESS.emitWarning === 'function' ? PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};

var AC = globalThis.AbortController;
var AS = globalThis.AbortSignal;
/* c8 ignore start */

if (typeof AC === 'undefined') {
  var _PROCESS$env;

  //@ts-ignore
  AS = /*#__PURE__*/function () {
    function AbortSignal() {
      _classCallCheck(this, AbortSignal);

      _defineProperty(this, "onabort", void 0);

      _defineProperty(this, "_onabort", []);

      _defineProperty(this, "reason", void 0);

      _defineProperty(this, "aborted", false);
    }

    _createClass(AbortSignal, [{
      key: "addEventListener",
      value: function addEventListener(_, fn) {
        this._onabort.push(fn);
      }
    }]);

    return AbortSignal;
  }(); //@ts-ignore


  AC = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      _defineProperty(this, "signal", new AS());

      warnACPolyfill();
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort(reason) {
        var _this$signal$onabort, _this$signal;

        if (this.signal.aborted) return; //@ts-ignore

        this.signal.reason = reason; //@ts-ignore

        this.signal.aborted = true; //@ts-ignore

        var _iterator = _createForOfIteratorHelper(this.signal._onabort),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fn = _step.value;
            fn(reason);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        (_this$signal$onabort = (_this$signal = this.signal).onabort) === null || _this$signal$onabort === void 0 ? void 0 : _this$signal$onabort.call(_this$signal, reason);
      }
    }]);

    return AbortController;
  }();

  var printACPolyfillWarning = ((_PROCESS$env = PROCESS.env) === null || _PROCESS$env === void 0 ? void 0 : _PROCESS$env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';

  var warnACPolyfill = function warnACPolyfill() {
    if (!printACPolyfillWarning) return;
    printACPolyfillWarning = false;
    emitWarning('AbortController is not defined. If using lru-cache in ' + 'node 14, load an AbortController polyfill from the ' + '`node-abort-controller` package. A minimal polyfill is ' + 'provided for use by LRUCache.fetch(), but it should not be ' + 'relied upon in other contexts (eg, passing it to other APIs that ' + 'use AbortController/AbortSignal might have undesirable effects). ' + 'You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.', 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
  };
}
/* c8 ignore stop */


var shouldWarn = function shouldWarn(code) {
  return !warned.has(code);
};

var TYPE = Symbol('type');

var isPosInt = function isPosInt(n) {
  return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */
// This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.


var getUintArray = function getUintArray(max) {
  return !isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? ZeroArray : null;
};
/* c8 ignore stop */


var ZeroArray = /*#__PURE__*/function (_Array) {
  _inherits(ZeroArray, _Array);

  var _super = _createSuper(ZeroArray);

  function ZeroArray(size) {
    var _this;

    _classCallCheck(this, ZeroArray);

    _this = _super.call(this, size);

    _this.fill(0);

    return _this;
  }

  return _createClass(ZeroArray);
}( /*#__PURE__*/_wrapNativeSuper(Array));

var Stack = /*#__PURE__*/function () {
  function Stack(max, HeapCls) {
    _classCallCheck(this, Stack);

    _defineProperty(this, "heap", void 0);

    _defineProperty(this, "length", void 0);

    /* c8 ignore start */
    if (!_classStaticPrivateFieldSpecGet(Stack, Stack, _constructing)) {
      throw new TypeError('instantiate Stack using Stack.create(n)');
    }
    /* c8 ignore stop */


    this.heap = new HeapCls(max);
    this.length = 0;
  }

  _createClass(Stack, [{
    key: "push",
    value: function push(n) {
      this.heap[this.length++] = n;
    }
  }, {
    key: "pop",
    value: function pop() {
      return this.heap[--this.length];
    }
  }], [{
    key: "create",
    value: // private constructor
    function create(max) {
      var HeapCls = getUintArray(max);
      if (!HeapCls) return [];

      _classStaticPrivateFieldSpecSet(Stack, Stack, _constructing, true);

      var s = new Stack(max, HeapCls);

      _classStaticPrivateFieldSpecSet(Stack, Stack, _constructing, false);

      return s;
    }
  }]);

  return Stack;
}();
/**
 * Default export, the thing you're using this module to get.
 *
 * All properties from the options object (with the exception of
 * {@link OptionsBase.max} and {@link OptionsBase.maxSize}) are added as
 * normal public members. (`max` and `maxBase` are read-only getters.)
 * Changing any of these will alter the defaults for subsequent method calls,
 * but is otherwise safe.
 */


var _constructing = {
  writable: true,
  value: false
};

var _max = /*#__PURE__*/new WeakMap();

var _maxSize = /*#__PURE__*/new WeakMap();

var _dispose = /*#__PURE__*/new WeakMap();

var _disposeAfter = /*#__PURE__*/new WeakMap();

var _fetchMethod = /*#__PURE__*/new WeakMap();

var _size = /*#__PURE__*/new WeakMap();

var _calculatedSize = /*#__PURE__*/new WeakMap();

var _keyMap = /*#__PURE__*/new WeakMap();

var _keyList = /*#__PURE__*/new WeakMap();

var _valList = /*#__PURE__*/new WeakMap();

var _next = /*#__PURE__*/new WeakMap();

var _prev = /*#__PURE__*/new WeakMap();

var _head = /*#__PURE__*/new WeakMap();

var _tail = /*#__PURE__*/new WeakMap();

var _free = /*#__PURE__*/new WeakMap();

var _disposed = /*#__PURE__*/new WeakMap();

var _sizes = /*#__PURE__*/new WeakMap();

var _starts = /*#__PURE__*/new WeakMap();

var _ttls = /*#__PURE__*/new WeakMap();

var _hasDispose = /*#__PURE__*/new WeakMap();

var _hasFetchMethod = /*#__PURE__*/new WeakMap();

var _hasDisposeAfter = /*#__PURE__*/new WeakMap();

var _initializeTTLTracking = /*#__PURE__*/new WeakSet();

var _updateItemAge = /*#__PURE__*/new WeakMap();

var _statusTTL = /*#__PURE__*/new WeakMap();

var _setItemTTL = /*#__PURE__*/new WeakMap();

var _isStale = /*#__PURE__*/new WeakMap();

var _initializeSizeTracking = /*#__PURE__*/new WeakSet();

var _removeItemSize = /*#__PURE__*/new WeakMap();

var _addItemSize = /*#__PURE__*/new WeakMap();

var _requireSize = /*#__PURE__*/new WeakMap();

var _indexes = /*#__PURE__*/new WeakSet();

var _rindexes = /*#__PURE__*/new WeakSet();

var _isValidIndex = /*#__PURE__*/new WeakSet();

var _evict = /*#__PURE__*/new WeakSet();

var _backgroundFetch = /*#__PURE__*/new WeakSet();

var _isBackgroundFetch = /*#__PURE__*/new WeakSet();

var _connect = /*#__PURE__*/new WeakSet();

var _moveToTail = /*#__PURE__*/new WeakSet();

_Symbol$iterator = Symbol.iterator;

var LRUCache = /*#__PURE__*/function () {
  function LRUCache(_options) {
    _classCallCheck(this, LRUCache);

    _classPrivateMethodInitSpec(this, _moveToTail);

    _classPrivateMethodInitSpec(this, _connect);

    _classPrivateMethodInitSpec(this, _isBackgroundFetch);

    _classPrivateMethodInitSpec(this, _backgroundFetch);

    _classPrivateMethodInitSpec(this, _evict);

    _classPrivateMethodInitSpec(this, _isValidIndex);

    _classPrivateMethodInitSpec(this, _rindexes);

    _classPrivateMethodInitSpec(this, _indexes);

    _classPrivateMethodInitSpec(this, _initializeSizeTracking);

    _classPrivateMethodInitSpec(this, _initializeTTLTracking);

    _classPrivateFieldInitSpec(this, _max, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _maxSize, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _dispose, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _disposeAfter, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _fetchMethod, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "ttl", void 0);

    _defineProperty(this, "ttlResolution", void 0);

    _defineProperty(this, "ttlAutopurge", void 0);

    _defineProperty(this, "updateAgeOnGet", void 0);

    _defineProperty(this, "updateAgeOnHas", void 0);

    _defineProperty(this, "allowStale", void 0);

    _defineProperty(this, "noDisposeOnSet", void 0);

    _defineProperty(this, "noUpdateTTL", void 0);

    _defineProperty(this, "maxEntrySize", void 0);

    _defineProperty(this, "sizeCalculation", void 0);

    _defineProperty(this, "noDeleteOnFetchRejection", void 0);

    _defineProperty(this, "noDeleteOnStaleGet", void 0);

    _defineProperty(this, "allowStaleOnFetchAbort", void 0);

    _defineProperty(this, "allowStaleOnFetchRejection", void 0);

    _defineProperty(this, "ignoreFetchAbort", void 0);

    _classPrivateFieldInitSpec(this, _size, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _calculatedSize, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _keyMap, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _keyList, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _valList, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _next, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _prev, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _head, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _tail, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _free, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _disposed, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _sizes, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _starts, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _ttls, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _hasDispose, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _hasFetchMethod, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _hasDisposeAfter, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _updateItemAge, {
      writable: true,
      value: function value() {}
    });

    _classPrivateFieldInitSpec(this, _statusTTL, {
      writable: true,
      value: function value() {}
    });

    _classPrivateFieldInitSpec(this, _setItemTTL, {
      writable: true,
      value: function value() {}
    });

    _classPrivateFieldInitSpec(this, _isStale, {
      writable: true,
      value: function value() {
        return false;
      }
    });

    _classPrivateFieldInitSpec(this, _removeItemSize, {
      writable: true,
      value: function value(_i) {}
    });

    _classPrivateFieldInitSpec(this, _addItemSize, {
      writable: true,
      value: function value(_i, _s, _st) {}
    });

    _classPrivateFieldInitSpec(this, _requireSize, {
      writable: true,
      value: function value(_k, _v, size, sizeCalculation) {
        if (size || sizeCalculation) {
          throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        }

        return 0;
      }
    });

    var _options$max = _options.max,
        max = _options$max === void 0 ? 0 : _options$max,
        _ttl = _options.ttl,
        _options$ttlResolutio = _options.ttlResolution,
        ttlResolution = _options$ttlResolutio === void 0 ? 1 : _options$ttlResolutio,
        ttlAutopurge = _options.ttlAutopurge,
        updateAgeOnGet = _options.updateAgeOnGet,
        updateAgeOnHas = _options.updateAgeOnHas,
        _allowStale = _options.allowStale,
        dispose = _options.dispose,
        disposeAfter = _options.disposeAfter,
        noDisposeOnSet = _options.noDisposeOnSet,
        noUpdateTTL = _options.noUpdateTTL,
        _options$maxSize = _options.maxSize,
        _maxSize2 = _options$maxSize === void 0 ? 0 : _options$maxSize,
        _options$maxEntrySize = _options.maxEntrySize,
        maxEntrySize = _options$maxEntrySize === void 0 ? 0 : _options$maxEntrySize,
        _sizeCalculation = _options.sizeCalculation,
        fetchMethod = _options.fetchMethod,
        noDeleteOnFetchRejection = _options.noDeleteOnFetchRejection,
        noDeleteOnStaleGet = _options.noDeleteOnStaleGet,
        allowStaleOnFetchRejection = _options.allowStaleOnFetchRejection,
        allowStaleOnFetchAbort = _options.allowStaleOnFetchAbort,
        ignoreFetchAbort = _options.ignoreFetchAbort;

    if (max !== 0 && !isPosInt(max)) {
      throw new TypeError('max option must be a nonnegative integer');
    }

    var UintArray = max ? getUintArray(max) : Array;

    if (!UintArray) {
      throw new Error('invalid max value: ' + max);
    }

    _classPrivateFieldSet(this, _max, max);

    _classPrivateFieldSet(this, _maxSize, _maxSize2);

    this.maxEntrySize = maxEntrySize || _classPrivateFieldGet(this, _maxSize);
    this.sizeCalculation = _sizeCalculation;

    if (this.sizeCalculation) {
      if (!_classPrivateFieldGet(this, _maxSize) && !this.maxEntrySize) {
        throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
      }

      if (typeof this.sizeCalculation !== 'function') {
        throw new TypeError('sizeCalculation set to non-function');
      }
    }

    if (fetchMethod !== undefined && typeof fetchMethod !== 'function') {
      throw new TypeError('fetchMethod must be a function if specified');
    }

    _classPrivateFieldSet(this, _fetchMethod, fetchMethod);

    _classPrivateFieldSet(this, _hasFetchMethod, !!fetchMethod);

    _classPrivateFieldSet(this, _keyMap, new Map());

    _classPrivateFieldSet(this, _keyList, new Array(max).fill(undefined));

    _classPrivateFieldSet(this, _valList, new Array(max).fill(undefined));

    _classPrivateFieldSet(this, _next, new UintArray(max));

    _classPrivateFieldSet(this, _prev, new UintArray(max));

    _classPrivateFieldSet(this, _head, 0);

    _classPrivateFieldSet(this, _tail, 0);

    _classPrivateFieldSet(this, _free, Stack.create(max));

    _classPrivateFieldSet(this, _size, 0);

    _classPrivateFieldSet(this, _calculatedSize, 0);

    if (typeof dispose === 'function') {
      _classPrivateFieldSet(this, _dispose, dispose);
    }

    if (typeof disposeAfter === 'function') {
      _classPrivateFieldSet(this, _disposeAfter, disposeAfter);

      _classPrivateFieldSet(this, _disposed, []);
    } else {
      _classPrivateFieldSet(this, _disposeAfter, undefined);

      _classPrivateFieldSet(this, _disposed, undefined);
    }

    _classPrivateFieldSet(this, _hasDispose, !!_classPrivateFieldGet(this, _dispose));

    _classPrivateFieldSet(this, _hasDisposeAfter, !!_classPrivateFieldGet(this, _disposeAfter));

    this.noDisposeOnSet = !!noDisposeOnSet;
    this.noUpdateTTL = !!noUpdateTTL;
    this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
    this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
    this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
    this.ignoreFetchAbort = !!ignoreFetchAbort; // NB: maxEntrySize is set to maxSize if it's set

    if (this.maxEntrySize !== 0) {
      if (_classPrivateFieldGet(this, _maxSize) !== 0) {
        if (!isPosInt(_classPrivateFieldGet(this, _maxSize))) {
          throw new TypeError('maxSize must be a positive integer if specified');
        }
      }

      if (!isPosInt(this.maxEntrySize)) {
        throw new TypeError('maxEntrySize must be a positive integer if specified');
      }

      _classPrivateMethodGet(this, _initializeSizeTracking, _initializeSizeTracking2).call(this);
    }

    this.allowStale = !!_allowStale;
    this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
    this.updateAgeOnGet = !!updateAgeOnGet;
    this.updateAgeOnHas = !!updateAgeOnHas;
    this.ttlResolution = isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
    this.ttlAutopurge = !!ttlAutopurge;
    this.ttl = _ttl || 0;

    if (this.ttl) {
      if (!isPosInt(this.ttl)) {
        throw new TypeError('ttl must be a positive integer if specified');
      }

      _classPrivateMethodGet(this, _initializeTTLTracking, _initializeTTLTracking2).call(this);
    } // do not allow completely unbounded caches


    if (_classPrivateFieldGet(this, _max) === 0 && this.ttl === 0 && _classPrivateFieldGet(this, _maxSize) === 0) {
      throw new TypeError('At least one of max, maxSize, or ttl is required');
    }

    if (!this.ttlAutopurge && !_classPrivateFieldGet(this, _max) && !_classPrivateFieldGet(this, _maxSize)) {
      var code = 'LRU_CACHE_UNBOUNDED';

      if (shouldWarn(code)) {
        warned.add(code);
        var msg = 'TTL caching without ttlAutopurge, max, or maxSize can ' + 'result in unbounded memory consumption.';
        emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
      }
    }
  }
  /**
   * Return the remaining TTL time for a given entry key
   */


  _createClass(LRUCache, [{
    key: "max",
    get: // Protected read-only members

    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */
    function get() {
      return _classPrivateFieldGet(this, _max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */

  }, {
    key: "maxSize",
    get: function get() {
      return _classPrivateFieldGet(this, _maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */

  }, {
    key: "calculatedSize",
    get: function get() {
      return _classPrivateFieldGet(this, _calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */

  }, {
    key: "size",
    get: function get() {
      return _classPrivateFieldGet(this, _size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */

  }, {
    key: "fetchMethod",
    get: function get() {
      return _classPrivateFieldGet(this, _fetchMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */

  }, {
    key: "dispose",
    get: function get() {
      return _classPrivateFieldGet(this, _dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */

  }, {
    key: "disposeAfter",
    get: function get() {
      return _classPrivateFieldGet(this, _disposeAfter);
    }
  }, {
    key: "getRemainingTTL",
    value: function getRemainingTTL(key) {
      return _classPrivateFieldGet(this, _keyMap).has(key) ? Infinity : 0;
    } // conditionally set private methods related to TTL

    /* c8 ignore stop */

  }, {
    key: "entries",
    value:
    /*#__PURE__*/

    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */
    _regeneratorRuntime.mark(function entries() {
      var _iterator2, _step2, i;

      return _regeneratorRuntime.wrap(function entries$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this));
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 10;
                break;
              }

              i = _step2.value;

              if (!(_classPrivateFieldGet(this, _valList)[i] !== undefined && _classPrivateFieldGet(this, _keyList)[i] !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return [_classPrivateFieldGet(this, _keyList)[i], _classPrivateFieldGet(this, _valList)[i]];

            case 8:
              _context.next = 3;
              break;

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 15:
              _context.prev = 15;

              _iterator2.f();

              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, entries, this, [[1, 12, 15, 18]]);
    })
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */

  }, {
    key: "rentries",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function rentries() {
      var _iterator3, _step3, i;

      return _regeneratorRuntime.wrap(function rentries$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this));
              _context2.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 10;
                break;
              }

              i = _step3.value;

              if (!(_classPrivateFieldGet(this, _valList)[i] !== undefined && _classPrivateFieldGet(this, _keyList)[i] !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return [_classPrivateFieldGet(this, _keyList)[i], _classPrivateFieldGet(this, _valList)[i]];

            case 8:
              _context2.next = 3;
              break;

            case 10:
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);

              _iterator3.e(_context2.t0);

            case 15:
              _context2.prev = 15;

              _iterator3.f();

              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, rentries, this, [[1, 12, 15, 18]]);
    })
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */

  }, {
    key: "keys",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function keys() {
      var _iterator4, _step4, i, k;

      return _regeneratorRuntime.wrap(function keys$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this));
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 11;
                break;
              }

              i = _step4.value;
              k = _classPrivateFieldGet(this, _keyList)[i];

              if (!(k !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context3.next = 9;
                break;
              }

              _context3.next = 9;
              return k;

            case 9:
              _context3.next = 3;
              break;

            case 11:
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);

              _iterator4.e(_context3.t0);

            case 16:
              _context3.prev = 16;

              _iterator4.f();

              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, keys, this, [[1, 13, 16, 19]]);
    })
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */

  }, {
    key: "rkeys",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function rkeys() {
      var _iterator5, _step5, i, k;

      return _regeneratorRuntime.wrap(function rkeys$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iterator5 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this));
              _context4.prev = 1;

              _iterator5.s();

            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context4.next = 11;
                break;
              }

              i = _step5.value;
              k = _classPrivateFieldGet(this, _keyList)[i];

              if (!(k !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context4.next = 9;
                break;
              }

              _context4.next = 9;
              return k;

            case 9:
              _context4.next = 3;
              break;

            case 11:
              _context4.next = 16;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](1);

              _iterator5.e(_context4.t0);

            case 16:
              _context4.prev = 16;

              _iterator5.f();

              return _context4.finish(16);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, rkeys, this, [[1, 13, 16, 19]]);
    })
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */

  }, {
    key: "values",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function values() {
      var _iterator6, _step6, i, v;

      return _regeneratorRuntime.wrap(function values$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this));
              _context5.prev = 1;

              _iterator6.s();

            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context5.next = 11;
                break;
              }

              i = _step6.value;
              v = _classPrivateFieldGet(this, _valList)[i];

              if (!(v !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context5.next = 9;
                break;
              }

              _context5.next = 9;
              return _classPrivateFieldGet(this, _valList)[i];

            case 9:
              _context5.next = 3;
              break;

            case 11:
              _context5.next = 16;
              break;

            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](1);

              _iterator6.e(_context5.t0);

            case 16:
              _context5.prev = 16;

              _iterator6.f();

              return _context5.finish(16);

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, values, this, [[1, 13, 16, 19]]);
    })
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */

  }, {
    key: "rvalues",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function rvalues() {
      var _iterator7, _step7, i, v;

      return _regeneratorRuntime.wrap(function rvalues$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _iterator7 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this));
              _context6.prev = 1;

              _iterator7.s();

            case 3:
              if ((_step7 = _iterator7.n()).done) {
                _context6.next = 11;
                break;
              }

              i = _step7.value;
              v = _classPrivateFieldGet(this, _valList)[i];

              if (!(v !== undefined && !_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, _classPrivateFieldGet(this, _valList)[i]))) {
                _context6.next = 9;
                break;
              }

              _context6.next = 9;
              return _classPrivateFieldGet(this, _valList)[i];

            case 9:
              _context6.next = 3;
              break;

            case 11:
              _context6.next = 16;
              break;

            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](1);

              _iterator7.e(_context6.t0);

            case 16:
              _context6.prev = 16;

              _iterator7.f();

              return _context6.finish(16);

            case 19:
            case "end":
              return _context6.stop();
          }
        }
      }, rvalues, this, [[1, 13, 16, 19]]);
    })
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */

  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to Array.find().  fn is called as fn(value, key, cache).
     */

  }, {
    key: "find",
    value: function find(fn) {
      var getOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _iterator8 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var i = _step8.value;

          var v = _classPrivateFieldGet(this, _valList)[i];

          var value = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
          if (value === undefined) continue;

          if (fn(value, _classPrivateFieldGet(this, _keyList)[i], this)) {
            return this.get(_classPrivateFieldGet(this, _keyList)[i], getOptions);
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    /**
     * Call the supplied function on each item in the cache, in order from
     * most recently used to least recently used.  fn is called as
     * fn(value, key, cache).  Does not update age or recenty of use.
     * Does not iterate over stale values.
     */

  }, {
    key: "forEach",
    value: function forEach(fn) {
      var thisp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      var _iterator9 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this)),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var i = _step9.value;

          var v = _classPrivateFieldGet(this, _valList)[i];

          var value = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
          if (value === undefined) continue;
          fn.call(thisp, value, _classPrivateFieldGet(this, _keyList)[i], this);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */

  }, {
    key: "rforEach",
    value: function rforEach(fn) {
      var thisp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      var _iterator10 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this)),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var i = _step10.value;

          var v = _classPrivateFieldGet(this, _valList)[i];

          var value = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
          if (value === undefined) continue;
          fn.call(thisp, value, _classPrivateFieldGet(this, _keyList)[i], this);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */

  }, {
    key: "purgeStale",
    value: function purgeStale() {
      var deleted = false;

      var _iterator11 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this, {
        allowStale: true
      })),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var i = _step11.value;

          if (_classPrivateFieldGet(this, _isStale).call(this, i)) {
            this.delete(_classPrivateFieldGet(this, _keyList)[i]);
            deleted = true;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Like {@link LRUCache#dump}, but just for a
     * single key. Always returns stale values, if their info is found in the
     * cache, so be sure to check for expired TTLs if relevant.
     */

  }, {
    key: "info",
    value: function info(key) {
      var i = _classPrivateFieldGet(this, _keyMap).get(key);

      if (i === undefined) return undefined;

      var v = _classPrivateFieldGet(this, _valList)[i];

      var value = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
      if (value === undefined) return undefined;
      var entry = {
        value: value
      };

      if (_classPrivateFieldGet(this, _ttls) && _classPrivateFieldGet(this, _starts)) {
        var ttl = _classPrivateFieldGet(this, _ttls)[i];

        var start = _classPrivateFieldGet(this, _starts)[i];

        if (ttl && start) {
          var remain = ttl - (perf.now() - start);
          entry.ttl = remain;
          entry.start = Date.now();
        }
      }

      if (_classPrivateFieldGet(this, _sizes)) {
        entry.size = _classPrivateFieldGet(this, _sizes)[i];
      }

      return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to cache.load()
     */

  }, {
    key: "dump",
    value: function dump() {
      var arr = [];

      var _iterator12 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _indexes, _indexes2).call(this, {
        allowStale: true
      })),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var i = _step12.value;

          var key = _classPrivateFieldGet(this, _keyList)[i];

          var v = _classPrivateFieldGet(this, _valList)[i];

          var value = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
          if (value === undefined || key === undefined) continue;
          var entry = {
            value: value
          };

          if (_classPrivateFieldGet(this, _ttls) && _classPrivateFieldGet(this, _starts)) {
            entry.ttl = _classPrivateFieldGet(this, _ttls)[i]; // always dump the start relative to a portable timestamp
            // it's ok for this to be a bit slow, it's a rare operation.

            var age = perf.now() - _classPrivateFieldGet(this, _starts)[i];

            entry.start = Math.floor(Date.now() - age);
          }

          if (_classPrivateFieldGet(this, _sizes)) {
            entry.size = _classPrivateFieldGet(this, _sizes)[i];
          }

          arr.unshift([key, entry]);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     * Note that the shape of the resulting cache may be different if the
     * same options are not used in both caches.
     */

  }, {
    key: "load",
    value: function load(arr) {
      this.clear();

      var _iterator13 = _createForOfIteratorHelper(arr),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _step13$value = _slicedToArray(_step13.value, 2),
              key = _step13$value[0],
              entry = _step13$value[1];

          if (entry.start) {
            // entry.start is a portable timestamp, but we may be using
            // node's performance.now(), so calculate the offset, so that
            // we get the intended remaining TTL, no matter how long it's
            // been on ice.
            //
            // it's ok for this to be a bit slow, it's a rare operation.
            var age = Date.now() - entry.start;
            entry.start = perf.now() - age;
          }

          this.set(key, entry.value, entry);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     */

  }, {
    key: "set",
    value: function set(k, v) {
      var setOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (v === undefined) {
        this.delete(k);
        return this;
      }

      var _setOptions$ttl = setOptions.ttl,
          ttl = _setOptions$ttl === void 0 ? this.ttl : _setOptions$ttl,
          start = setOptions.start,
          _setOptions$noDispose = setOptions.noDisposeOnSet,
          noDisposeOnSet = _setOptions$noDispose === void 0 ? this.noDisposeOnSet : _setOptions$noDispose,
          _setOptions$sizeCalcu = setOptions.sizeCalculation,
          sizeCalculation = _setOptions$sizeCalcu === void 0 ? this.sizeCalculation : _setOptions$sizeCalcu,
          status = setOptions.status;
      var _setOptions$noUpdateT = setOptions.noUpdateTTL,
          noUpdateTTL = _setOptions$noUpdateT === void 0 ? this.noUpdateTTL : _setOptions$noUpdateT;

      var size = _classPrivateFieldGet(this, _requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation); // if the item doesn't fit, don't do anything
      // NB: maxEntrySize set to maxSize by default


      if (this.maxEntrySize && size > this.maxEntrySize) {
        if (status) {
          status.set = 'miss';
          status.maxEntrySizeExceeded = true;
        } // have to delete, in case something is there already.


        this.delete(k);
        return this;
      }

      var index = _classPrivateFieldGet(this, _size) === 0 ? undefined : _classPrivateFieldGet(this, _keyMap).get(k);

      if (index === undefined) {
        var _this$size, _this$size2;

        // addition
        index = _classPrivateFieldGet(this, _size) === 0 ? _classPrivateFieldGet(this, _tail) : _classPrivateFieldGet(this, _free).length !== 0 ? _classPrivateFieldGet(this, _free).pop() : _classPrivateFieldGet(this, _size) === _classPrivateFieldGet(this, _max) ? _classPrivateMethodGet(this, _evict, _evict2).call(this, false) : _classPrivateFieldGet(this, _size);
        _classPrivateFieldGet(this, _keyList)[index] = k;
        _classPrivateFieldGet(this, _valList)[index] = v;

        _classPrivateFieldGet(this, _keyMap).set(k, index);

        _classPrivateFieldGet(this, _next)[_classPrivateFieldGet(this, _tail)] = index;
        _classPrivateFieldGet(this, _prev)[index] = _classPrivateFieldGet(this, _tail);

        _classPrivateFieldSet(this, _tail, index);

        _classPrivateFieldSet(this, _size, (_this$size = _classPrivateFieldGet(this, _size), _this$size2 = _this$size++, _this$size)), _this$size2;

        _classPrivateFieldGet(this, _addItemSize).call(this, index, size, status);

        if (status) status.set = 'add';
        noUpdateTTL = false;
      } else {
        // update
        _classPrivateMethodGet(this, _moveToTail, _moveToTail2).call(this, index);

        var oldVal = _classPrivateFieldGet(this, _valList)[index];

        if (v !== oldVal) {
          if (_classPrivateFieldGet(this, _hasFetchMethod) && _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, oldVal)) {
            oldVal.__abortController.abort(new Error('replaced'));

            var s = oldVal.__staleWhileFetching;

            if (s !== undefined && !noDisposeOnSet) {
              if (_classPrivateFieldGet(this, _hasDispose)) {
                var _classPrivateFieldGet2;

                (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _dispose)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.call(this, s, k, 'set');
              }

              if (_classPrivateFieldGet(this, _hasDisposeAfter)) {
                var _classPrivateFieldGet3;

                (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _disposed)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.push([s, k, 'set']);
              }
            }
          } else if (!noDisposeOnSet) {
            if (_classPrivateFieldGet(this, _hasDispose)) {
              var _classPrivateFieldGet4;

              (_classPrivateFieldGet4 = _classPrivateFieldGet(this, _dispose)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.call(this, oldVal, k, 'set');
            }

            if (_classPrivateFieldGet(this, _hasDisposeAfter)) {
              var _classPrivateFieldGet5;

              (_classPrivateFieldGet5 = _classPrivateFieldGet(this, _disposed)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.push([oldVal, k, 'set']);
            }
          }

          _classPrivateFieldGet(this, _removeItemSize).call(this, index);

          _classPrivateFieldGet(this, _addItemSize).call(this, index, size, status);

          _classPrivateFieldGet(this, _valList)[index] = v;

          if (status) {
            status.set = 'replace';
            var oldValue = oldVal && _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
            if (oldValue !== undefined) status.oldValue = oldValue;
          }
        } else if (status) {
          status.set = 'update';
        }
      }

      if (ttl !== 0 && !_classPrivateFieldGet(this, _ttls)) {
        _classPrivateMethodGet(this, _initializeTTLTracking, _initializeTTLTracking2).call(this);
      }

      if (_classPrivateFieldGet(this, _ttls)) {
        if (!noUpdateTTL) {
          _classPrivateFieldGet(this, _setItemTTL).call(this, index, ttl, start);
        }

        if (status) _classPrivateFieldGet(this, _statusTTL).call(this, status, index);
      }

      if (!noDisposeOnSet && _classPrivateFieldGet(this, _hasDisposeAfter) && _classPrivateFieldGet(this, _disposed)) {
        var dt = _classPrivateFieldGet(this, _disposed);

        var task;

        while (task = dt === null || dt === void 0 ? void 0 : dt.shift()) {
          var _classPrivateFieldGet6, _classPrivateFieldGet7;

          (_classPrivateFieldGet6 = _classPrivateFieldGet(this, _disposeAfter)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : (_classPrivateFieldGet7 = _classPrivateFieldGet6).call.apply(_classPrivateFieldGet7, [this].concat(_toConsumableArray(task)));
        }
      }

      return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */

  }, {
    key: "pop",
    value: function pop() {
      try {
        while (_classPrivateFieldGet(this, _size)) {
          var val = _classPrivateFieldGet(this, _valList)[_classPrivateFieldGet(this, _head)];

          _classPrivateMethodGet(this, _evict, _evict2).call(this, true);

          if (_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, val)) {
            if (val.__staleWhileFetching) {
              return val.__staleWhileFetching;
            }
          } else if (val !== undefined) {
            return val;
          }
        }
      } finally {
        if (_classPrivateFieldGet(this, _hasDisposeAfter) && _classPrivateFieldGet(this, _disposed)) {
          var dt = _classPrivateFieldGet(this, _disposed);

          var task;

          while (task = dt === null || dt === void 0 ? void 0 : dt.shift()) {
            var _classPrivateFieldGet8, _classPrivateFieldGet9;

            (_classPrivateFieldGet8 = _classPrivateFieldGet(this, _disposeAfter)) === null || _classPrivateFieldGet8 === void 0 ? void 0 : (_classPrivateFieldGet9 = _classPrivateFieldGet8).call.apply(_classPrivateFieldGet9, [this].concat(_toConsumableArray(task)));
          }
        }
      }
    }
  }, {
    key: "has",
    value:
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */
    function has(k) {
      var hasOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _hasOptions$updateAge = hasOptions.updateAgeOnHas,
          updateAgeOnHas = _hasOptions$updateAge === void 0 ? this.updateAgeOnHas : _hasOptions$updateAge,
          status = hasOptions.status;

      var index = _classPrivateFieldGet(this, _keyMap).get(k);

      if (index !== undefined) {
        var v = _classPrivateFieldGet(this, _valList)[index];

        if (_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) && v.__staleWhileFetching === undefined) {
          return false;
        }

        if (!_classPrivateFieldGet(this, _isStale).call(this, index)) {
          if (updateAgeOnHas) {
            _classPrivateFieldGet(this, _updateItemAge).call(this, index);
          }

          if (status) {
            status.has = 'hit';

            _classPrivateFieldGet(this, _statusTTL).call(this, status, index);
          }

          return true;
        } else if (status) {
          status.has = 'stale';

          _classPrivateFieldGet(this, _statusTTL).call(this, status, index);
        }
      } else if (status) {
        status.has = 'miss';
      }

      return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */

  }, {
    key: "peek",
    value: function peek(k) {
      var peekOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _peekOptions$allowSta = peekOptions.allowStale,
          allowStale = _peekOptions$allowSta === void 0 ? this.allowStale : _peekOptions$allowSta;

      var index = _classPrivateFieldGet(this, _keyMap).get(k);

      if (index === undefined || !allowStale && _classPrivateFieldGet(this, _isStale).call(this, index)) {
        return;
      }

      var v = _classPrivateFieldGet(this, _valList)[index]; // either stale and allowed, or forcing a refresh of non-stale value


      return _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v) ? v.__staleWhileFetching : v;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(k) {
        var fetchOptions,
            _fetchOptions$allowSt,
            allowStale,
            _fetchOptions$updateA,
            updateAgeOnGet,
            _fetchOptions$noDelet,
            noDeleteOnStaleGet,
            _fetchOptions$ttl,
            ttl,
            _fetchOptions$noDispo,
            noDisposeOnSet,
            _fetchOptions$size,
            size,
            _fetchOptions$sizeCal,
            sizeCalculation,
            _fetchOptions$noUpdat,
            noUpdateTTL,
            _fetchOptions$noDelet2,
            noDeleteOnFetchRejection,
            _fetchOptions$allowSt2,
            allowStaleOnFetchRejection,
            _fetchOptions$ignoreF,
            ignoreFetchAbort,
            _fetchOptions$allowSt3,
            allowStaleOnFetchAbort,
            context,
            _fetchOptions$forceRe,
            forceRefresh,
            status,
            signal,
            options,
            index,
            p,
            v,
            stale,
            isStale,
            _p,
            hasStale,
            staleVal,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                fetchOptions = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                _fetchOptions$allowSt = fetchOptions.allowStale, allowStale = _fetchOptions$allowSt === void 0 ? this.allowStale : _fetchOptions$allowSt, _fetchOptions$updateA = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions$updateA === void 0 ? this.updateAgeOnGet : _fetchOptions$updateA, _fetchOptions$noDelet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions$noDelet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions$noDelet, _fetchOptions$ttl = fetchOptions.ttl, ttl = _fetchOptions$ttl === void 0 ? this.ttl : _fetchOptions$ttl, _fetchOptions$noDispo = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions$noDispo === void 0 ? this.noDisposeOnSet : _fetchOptions$noDispo, _fetchOptions$size = fetchOptions.size, size = _fetchOptions$size === void 0 ? 0 : _fetchOptions$size, _fetchOptions$sizeCal = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions$sizeCal === void 0 ? this.sizeCalculation : _fetchOptions$sizeCal, _fetchOptions$noUpdat = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions$noUpdat === void 0 ? this.noUpdateTTL : _fetchOptions$noUpdat, _fetchOptions$noDelet2 = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions$noDelet2 === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions$noDelet2, _fetchOptions$allowSt2 = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions$allowSt2 === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions$allowSt2, _fetchOptions$ignoreF = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions$ignoreF === void 0 ? this.ignoreFetchAbort : _fetchOptions$ignoreF, _fetchOptions$allowSt3 = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions$allowSt3 === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions$allowSt3, context = fetchOptions.context, _fetchOptions$forceRe = fetchOptions.forceRefresh, forceRefresh = _fetchOptions$forceRe === void 0 ? false : _fetchOptions$forceRe, status = fetchOptions.status, signal = fetchOptions.signal;

                if (_classPrivateFieldGet(this, _hasFetchMethod)) {
                  _context7.next = 5;
                  break;
                }

                if (status) status.fetch = 'get';
                return _context7.abrupt("return", this.get(k, {
                  allowStale: allowStale,
                  updateAgeOnGet: updateAgeOnGet,
                  noDeleteOnStaleGet: noDeleteOnStaleGet,
                  status: status
                }));

              case 5:
                options = {
                  allowStale: allowStale,
                  updateAgeOnGet: updateAgeOnGet,
                  noDeleteOnStaleGet: noDeleteOnStaleGet,
                  ttl: ttl,
                  noDisposeOnSet: noDisposeOnSet,
                  size: size,
                  sizeCalculation: sizeCalculation,
                  noUpdateTTL: noUpdateTTL,
                  noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                  allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                  allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                  ignoreFetchAbort: ignoreFetchAbort,
                  status: status,
                  signal: signal
                };
                index = _classPrivateFieldGet(this, _keyMap).get(k);

                if (!(index === undefined)) {
                  _context7.next = 13;
                  break;
                }

                if (status) status.fetch = 'miss';
                p = _classPrivateMethodGet(this, _backgroundFetch, _backgroundFetch2).call(this, k, index, options, context);
                return _context7.abrupt("return", p.__returned = p);

              case 13:
                // in cache, maybe already fetching
                v = _classPrivateFieldGet(this, _valList)[index];

                if (!_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v)) {
                  _context7.next = 18;
                  break;
                }

                stale = allowStale && v.__staleWhileFetching !== undefined;

                if (status) {
                  status.fetch = 'inflight';
                  if (stale) status.returnedStale = true;
                }

                return _context7.abrupt("return", stale ? v.__staleWhileFetching : v.__returned = v);

              case 18:
                // if we force a refresh, that means do NOT serve the cached value,
                // unless we are already in the process of refreshing the cache.
                isStale = _classPrivateFieldGet(this, _isStale).call(this, index);

                if (!(!forceRefresh && !isStale)) {
                  _context7.next = 25;
                  break;
                }

                if (status) status.fetch = 'hit';

                _classPrivateMethodGet(this, _moveToTail, _moveToTail2).call(this, index);

                if (updateAgeOnGet) {
                  _classPrivateFieldGet(this, _updateItemAge).call(this, index);
                }

                if (status) _classPrivateFieldGet(this, _statusTTL).call(this, status, index);
                return _context7.abrupt("return", v);

              case 25:
                // ok, it is stale or a forced refresh, and not already fetching.
                // refresh the cache.
                _p = _classPrivateMethodGet(this, _backgroundFetch, _backgroundFetch2).call(this, k, index, options, context);
                hasStale = _p.__staleWhileFetching !== undefined;
                staleVal = hasStale && allowStale;

                if (status) {
                  status.fetch = isStale ? 'stale' : 'refresh';
                  if (staleVal && isStale) status.returnedStale = true;
                }

                return _context7.abrupt("return", staleVal ? _p.__staleWhileFetching : _p.__returned = _p);

              case 30:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */

  }, {
    key: "get",
    value: function get(k) {
      var getOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _getOptions$allowStal = getOptions.allowStale,
          allowStale = _getOptions$allowStal === void 0 ? this.allowStale : _getOptions$allowStal,
          _getOptions$updateAge = getOptions.updateAgeOnGet,
          updateAgeOnGet = _getOptions$updateAge === void 0 ? this.updateAgeOnGet : _getOptions$updateAge,
          _getOptions$noDeleteO = getOptions.noDeleteOnStaleGet,
          noDeleteOnStaleGet = _getOptions$noDeleteO === void 0 ? this.noDeleteOnStaleGet : _getOptions$noDeleteO,
          status = getOptions.status;

      var index = _classPrivateFieldGet(this, _keyMap).get(k);

      if (index !== undefined) {
        var value = _classPrivateFieldGet(this, _valList)[index];

        var fetching = _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, value);

        if (status) _classPrivateFieldGet(this, _statusTTL).call(this, status, index);

        if (_classPrivateFieldGet(this, _isStale).call(this, index)) {
          if (status) status.get = 'stale'; // delete only if not an in-flight background fetch

          if (!fetching) {
            if (!noDeleteOnStaleGet) {
              this.delete(k);
            }

            if (status && allowStale) status.returnedStale = true;
            return allowStale ? value : undefined;
          } else {
            if (status && allowStale && value.__staleWhileFetching !== undefined) {
              status.returnedStale = true;
            }

            return allowStale ? value.__staleWhileFetching : undefined;
          }
        } else {
          if (status) status.get = 'hit'; // if we're currently fetching it, we don't actually have it yet
          // it's not stale, which means this isn't a staleWhileRefetching.
          // If it's not stale, and fetching, AND has a __staleWhileFetching
          // value, then that means the user fetched with {forceRefresh:true},
          // so it's safe to return that value.

          if (fetching) {
            return value.__staleWhileFetching;
          }

          _classPrivateMethodGet(this, _moveToTail, _moveToTail2).call(this, index);

          if (updateAgeOnGet) {
            _classPrivateFieldGet(this, _updateItemAge).call(this, index);
          }

          return value;
        }
      } else if (status) {
        status.get = 'miss';
      }
    }
  }, {
    key: "delete",
    value:
    /**
     * Deletes a key out of the cache.
     * Returns true if the key was deleted, false otherwise.
     */
    function _delete(k) {
      var _classPrivateFieldGet12;

      var deleted = false;

      if (_classPrivateFieldGet(this, _size) !== 0) {
        var index = _classPrivateFieldGet(this, _keyMap).get(k);

        if (index !== undefined) {
          deleted = true;

          if (_classPrivateFieldGet(this, _size) === 1) {
            this.clear();
          } else {
            var _this$size5, _this$size6;

            _classPrivateFieldGet(this, _removeItemSize).call(this, index);

            var v = _classPrivateFieldGet(this, _valList)[index];

            if (_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v)) {
              v.__abortController.abort(new Error('deleted'));
            } else if (_classPrivateFieldGet(this, _hasDispose) || _classPrivateFieldGet(this, _hasDisposeAfter)) {
              if (_classPrivateFieldGet(this, _hasDispose)) {
                var _classPrivateFieldGet10;

                (_classPrivateFieldGet10 = _classPrivateFieldGet(this, _dispose)) === null || _classPrivateFieldGet10 === void 0 ? void 0 : _classPrivateFieldGet10.call(this, v, k, 'delete');
              }

              if (_classPrivateFieldGet(this, _hasDisposeAfter)) {
                var _classPrivateFieldGet11;

                (_classPrivateFieldGet11 = _classPrivateFieldGet(this, _disposed)) === null || _classPrivateFieldGet11 === void 0 ? void 0 : _classPrivateFieldGet11.push([v, k, 'delete']);
              }
            }

            _classPrivateFieldGet(this, _keyMap).delete(k);

            _classPrivateFieldGet(this, _keyList)[index] = undefined;
            _classPrivateFieldGet(this, _valList)[index] = undefined;

            if (index === _classPrivateFieldGet(this, _tail)) {
              _classPrivateFieldSet(this, _tail, _classPrivateFieldGet(this, _prev)[index]);
            } else if (index === _classPrivateFieldGet(this, _head)) {
              _classPrivateFieldSet(this, _head, _classPrivateFieldGet(this, _next)[index]);
            } else {
              var pi = _classPrivateFieldGet(this, _prev)[index];

              _classPrivateFieldGet(this, _next)[pi] = _classPrivateFieldGet(this, _next)[index];

              var ni = _classPrivateFieldGet(this, _next)[index];

              _classPrivateFieldGet(this, _prev)[ni] = _classPrivateFieldGet(this, _prev)[index];
            }

            _classPrivateFieldSet(this, _size, (_this$size5 = _classPrivateFieldGet(this, _size), _this$size6 = _this$size5--, _this$size5)), _this$size6;

            _classPrivateFieldGet(this, _free).push(index);
          }
        }
      }

      if (_classPrivateFieldGet(this, _hasDisposeAfter) && (_classPrivateFieldGet12 = _classPrivateFieldGet(this, _disposed)) !== null && _classPrivateFieldGet12 !== void 0 && _classPrivateFieldGet12.length) {
        var dt = _classPrivateFieldGet(this, _disposed);

        var task;

        while (task = dt === null || dt === void 0 ? void 0 : dt.shift()) {
          var _classPrivateFieldGet13, _classPrivateFieldGet14;

          (_classPrivateFieldGet13 = _classPrivateFieldGet(this, _disposeAfter)) === null || _classPrivateFieldGet13 === void 0 ? void 0 : (_classPrivateFieldGet14 = _classPrivateFieldGet13).call.apply(_classPrivateFieldGet14, [this].concat(_toConsumableArray(task)));
        }
      }

      return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */

  }, {
    key: "clear",
    value: function clear() {
      var _iterator14 = _createForOfIteratorHelper(_classPrivateMethodGet(this, _rindexes, _rindexes2).call(this, {
        allowStale: true
      })),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var index = _step14.value;

          var v = _classPrivateFieldGet(this, _valList)[index];

          if (_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v)) {
            v.__abortController.abort(new Error('deleted'));
          } else {
            var k = _classPrivateFieldGet(this, _keyList)[index];

            if (_classPrivateFieldGet(this, _hasDispose)) {
              var _classPrivateFieldGet17;

              (_classPrivateFieldGet17 = _classPrivateFieldGet(this, _dispose)) === null || _classPrivateFieldGet17 === void 0 ? void 0 : _classPrivateFieldGet17.call(this, v, k, 'delete');
            }

            if (_classPrivateFieldGet(this, _hasDisposeAfter)) {
              var _classPrivateFieldGet18;

              (_classPrivateFieldGet18 = _classPrivateFieldGet(this, _disposed)) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.push([v, k, 'delete']);
            }
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      _classPrivateFieldGet(this, _keyMap).clear();

      _classPrivateFieldGet(this, _valList).fill(undefined);

      _classPrivateFieldGet(this, _keyList).fill(undefined);

      if (_classPrivateFieldGet(this, _ttls) && _classPrivateFieldGet(this, _starts)) {
        _classPrivateFieldGet(this, _ttls).fill(0);

        _classPrivateFieldGet(this, _starts).fill(0);
      }

      if (_classPrivateFieldGet(this, _sizes)) {
        _classPrivateFieldGet(this, _sizes).fill(0);
      }

      _classPrivateFieldSet(this, _head, 0);

      _classPrivateFieldSet(this, _tail, 0);

      _classPrivateFieldGet(this, _free).length = 0;

      _classPrivateFieldSet(this, _calculatedSize, 0);

      _classPrivateFieldSet(this, _size, 0);

      if (_classPrivateFieldGet(this, _hasDisposeAfter) && _classPrivateFieldGet(this, _disposed)) {
        var dt = _classPrivateFieldGet(this, _disposed);

        var task;

        while (task = dt === null || dt === void 0 ? void 0 : dt.shift()) {
          var _classPrivateFieldGet15, _classPrivateFieldGet16;

          (_classPrivateFieldGet15 = _classPrivateFieldGet(this, _disposeAfter)) === null || _classPrivateFieldGet15 === void 0 ? void 0 : (_classPrivateFieldGet16 = _classPrivateFieldGet15).call.apply(_classPrivateFieldGet16, [this].concat(_toConsumableArray(task)));
        }
      }
    }
  }], [{
    key: "unsafeExposeInternals",
    value: // properties coming in from the options of these, only max and maxSize
    // really *need* to be protected. The rest can be modified, as they just
    // set defaults for various methods.

    /**
     * {@link LRUCache.OptionsBase.ttl}
     */

    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */

    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */

    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */

    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */

    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */

    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */

    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */

    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */

    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */

    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */

    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */

    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */

    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */

    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */
    // computed properties

    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */
    function unsafeExposeInternals(c) {
      return {
        // properties
        starts: _classPrivateFieldGet(c, _starts),
        ttls: _classPrivateFieldGet(c, _ttls),
        sizes: _classPrivateFieldGet(c, _sizes),
        keyMap: _classPrivateFieldGet(c, _keyMap),
        keyList: _classPrivateFieldGet(c, _keyList),
        valList: _classPrivateFieldGet(c, _valList),
        next: _classPrivateFieldGet(c, _next),
        prev: _classPrivateFieldGet(c, _prev),

        get head() {
          return _classPrivateFieldGet(c, _head);
        },

        get tail() {
          return _classPrivateFieldGet(c, _tail);
        },

        free: _classPrivateFieldGet(c, _free),
        // methods
        isBackgroundFetch: function isBackgroundFetch(p) {
          return _classPrivateMethodGet(c, _isBackgroundFetch, _isBackgroundFetch2).call(c, p);
        },
        backgroundFetch: function backgroundFetch(k, index, options, context) {
          return _classPrivateMethodGet(c, _backgroundFetch, _backgroundFetch2).call(c, k, index, options, context);
        },
        moveToTail: function moveToTail(index) {
          return _classPrivateMethodGet(c, _moveToTail, _moveToTail2).call(c, index);
        },
        indexes: function indexes(options) {
          return _classPrivateMethodGet(c, _indexes, _indexes2).call(c, options);
        },
        rindexes: function rindexes(options) {
          return _classPrivateMethodGet(c, _rindexes, _rindexes2).call(c, options);
        },
        isStale: function isStale(index) {
          return _classPrivateFieldGet(c, _isStale).call(c, index);
        }
      };
    }
  }]);

  return LRUCache;
}();

function _initializeTTLTracking2() {
  var _this2 = this;

  var ttls = new ZeroArray(_classPrivateFieldGet(this, _max));
  var starts = new ZeroArray(_classPrivateFieldGet(this, _max));

  _classPrivateFieldSet(this, _ttls, ttls);

  _classPrivateFieldSet(this, _starts, starts);

  _classPrivateFieldSet(this, _setItemTTL, function (index, ttl) {
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : perf.now();
    starts[index] = ttl !== 0 ? start : 0;
    ttls[index] = ttl;

    if (ttl !== 0 && _this2.ttlAutopurge) {
      var t = setTimeout(function () {
        if (_classPrivateFieldGet(_this2, _isStale).call(_this2, index)) {
          _this2.delete(_classPrivateFieldGet(_this2, _keyList)[index]);
        }
      }, ttl + 1); // unref() not supported on all platforms

      /* c8 ignore start */

      if (t.unref) {
        t.unref();
      }
      /* c8 ignore stop */

    }
  });

  _classPrivateFieldSet(this, _updateItemAge, function (index) {
    starts[index] = ttls[index] !== 0 ? perf.now() : 0;
  });

  _classPrivateFieldSet(this, _statusTTL, function (status, index) {
    if (ttls[index]) {
      var ttl = ttls[index];
      var start = starts[index];
      /* c8 ignore next */

      if (!ttl || !start) return;
      status.ttl = ttl;
      status.start = start;
      status.now = cachedNow || getNow();
      var age = status.now - start;
      status.remainingTTL = ttl - age;
    }
  }); // debounce calls to perf.now() to 1s so we're not hitting
  // that costly call repeatedly.


  var cachedNow = 0;

  var getNow = function getNow() {
    var n = perf.now();

    if (_this2.ttlResolution > 0) {
      cachedNow = n;
      var t = setTimeout(function () {
        return cachedNow = 0;
      }, _this2.ttlResolution); // not available on all platforms

      /* c8 ignore start */

      if (t.unref) {
        t.unref();
      }
      /* c8 ignore stop */

    }

    return n;
  };

  this.getRemainingTTL = function (key) {
    var index = _classPrivateFieldGet(_this2, _keyMap).get(key);

    if (index === undefined) {
      return 0;
    }

    var ttl = ttls[index];
    var start = starts[index];

    if (!ttl || !start) {
      return Infinity;
    }

    var age = (cachedNow || getNow()) - start;
    return ttl - age;
  };

  _classPrivateFieldSet(this, _isStale, function (index) {
    var s = starts[index];
    var t = ttls[index];
    return !!t && !!s && (cachedNow || getNow()) - s > t;
  });
}

function _initializeSizeTracking2() {
  var _this3 = this;

  var sizes = new ZeroArray(_classPrivateFieldGet(this, _max));

  _classPrivateFieldSet(this, _calculatedSize, 0);

  _classPrivateFieldSet(this, _sizes, sizes);

  _classPrivateFieldSet(this, _removeItemSize, function (index) {
    _classPrivateFieldSet(_this3, _calculatedSize, _classPrivateFieldGet(_this3, _calculatedSize) - sizes[index]);

    sizes[index] = 0;
  });

  _classPrivateFieldSet(this, _requireSize, function (k, v, size, sizeCalculation) {
    // provisionally accept background fetches.
    // actual value size will be checked when they return.
    if (_classPrivateMethodGet(_this3, _isBackgroundFetch, _isBackgroundFetch2).call(_this3, v)) {
      return 0;
    }

    if (!isPosInt(size)) {
      if (sizeCalculation) {
        if (typeof sizeCalculation !== 'function') {
          throw new TypeError('sizeCalculation must be a function');
        }

        size = sizeCalculation(v, k);

        if (!isPosInt(size)) {
          throw new TypeError('sizeCalculation return invalid (expect positive integer)');
        }
      } else {
        throw new TypeError('invalid size value (must be positive integer). ' + 'When maxSize or maxEntrySize is used, sizeCalculation ' + 'or size must be set.');
      }
    }

    return size;
  });

  _classPrivateFieldSet(this, _addItemSize, function (index, size, status) {
    sizes[index] = size;

    if (_classPrivateFieldGet(_this3, _maxSize)) {
      var maxSize = _classPrivateFieldGet(_this3, _maxSize) - sizes[index];

      while (_classPrivateFieldGet(_this3, _calculatedSize) > maxSize) {
        _classPrivateMethodGet(_this3, _evict, _evict2).call(_this3, true);
      }
    }

    _classPrivateFieldSet(_this3, _calculatedSize, _classPrivateFieldGet(_this3, _calculatedSize) + sizes[index]);

    if (status) {
      status.entrySize = size;
      status.totalCalculatedSize = _classPrivateFieldGet(_this3, _calculatedSize);
    }
  });
}

function _indexes2() {
  var _ref,
      _ref$allowStale,
      allowStale,
      i,
      _args8 = arguments;

  return _regeneratorRuntime.wrap(function _indexes2$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, _ref$allowStale = _ref.allowStale, allowStale = _ref$allowStale === void 0 ? this.allowStale : _ref$allowStale;

          if (!_classPrivateFieldGet(this, _size)) {
            _context8.next = 16;
            break;
          }

          i = _classPrivateFieldGet(this, _tail);

        case 3:
          if (!true) {
            _context8.next = 16;
            break;
          }

          if (_classPrivateMethodGet(this, _isValidIndex, _isValidIndex2).call(this, i)) {
            _context8.next = 6;
            break;
          }

          return _context8.abrupt("break", 16);

        case 6:
          if (!(allowStale || !_classPrivateFieldGet(this, _isStale).call(this, i))) {
            _context8.next = 9;
            break;
          }

          _context8.next = 9;
          return i;

        case 9:
          if (!(i === _classPrivateFieldGet(this, _head))) {
            _context8.next = 13;
            break;
          }

          return _context8.abrupt("break", 16);

        case 13:
          i = _classPrivateFieldGet(this, _prev)[i];

        case 14:
          _context8.next = 3;
          break;

        case 16:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked, this);
}

function _rindexes2() {
  var _ref2,
      _ref2$allowStale,
      allowStale,
      i,
      _args9 = arguments;

  return _regeneratorRuntime.wrap(function _rindexes2$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref2 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, _ref2$allowStale = _ref2.allowStale, allowStale = _ref2$allowStale === void 0 ? this.allowStale : _ref2$allowStale;

          if (!_classPrivateFieldGet(this, _size)) {
            _context9.next = 16;
            break;
          }

          i = _classPrivateFieldGet(this, _head);

        case 3:
          if (!true) {
            _context9.next = 16;
            break;
          }

          if (_classPrivateMethodGet(this, _isValidIndex, _isValidIndex2).call(this, i)) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt("break", 16);

        case 6:
          if (!(allowStale || !_classPrivateFieldGet(this, _isStale).call(this, i))) {
            _context9.next = 9;
            break;
          }

          _context9.next = 9;
          return i;

        case 9:
          if (!(i === _classPrivateFieldGet(this, _tail))) {
            _context9.next = 13;
            break;
          }

          return _context9.abrupt("break", 16);

        case 13:
          i = _classPrivateFieldGet(this, _next)[i];

        case 14:
          _context9.next = 3;
          break;

        case 16:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked2, this);
}

function _isValidIndex2(index) {
  return index !== undefined && _classPrivateFieldGet(this, _keyMap).get(_classPrivateFieldGet(this, _keyList)[index]) === index;
}

function _evict2(free) {
  var _this$size3, _this$size4;

  var head = _classPrivateFieldGet(this, _head);

  var k = _classPrivateFieldGet(this, _keyList)[head];

  var v = _classPrivateFieldGet(this, _valList)[head];

  if (_classPrivateFieldGet(this, _hasFetchMethod) && _classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v)) {
    v.__abortController.abort(new Error('evicted'));
  } else if (_classPrivateFieldGet(this, _hasDispose) || _classPrivateFieldGet(this, _hasDisposeAfter)) {
    if (_classPrivateFieldGet(this, _hasDispose)) {
      var _classPrivateFieldGet19;

      (_classPrivateFieldGet19 = _classPrivateFieldGet(this, _dispose)) === null || _classPrivateFieldGet19 === void 0 ? void 0 : _classPrivateFieldGet19.call(this, v, k, 'evict');
    }

    if (_classPrivateFieldGet(this, _hasDisposeAfter)) {
      var _classPrivateFieldGet20;

      (_classPrivateFieldGet20 = _classPrivateFieldGet(this, _disposed)) === null || _classPrivateFieldGet20 === void 0 ? void 0 : _classPrivateFieldGet20.push([v, k, 'evict']);
    }
  }

  _classPrivateFieldGet(this, _removeItemSize).call(this, head); // if we aren't about to use the index, then null these out


  if (free) {
    _classPrivateFieldGet(this, _keyList)[head] = undefined;
    _classPrivateFieldGet(this, _valList)[head] = undefined;

    _classPrivateFieldGet(this, _free).push(head);
  }

  if (_classPrivateFieldGet(this, _size) === 1) {
    _classPrivateFieldSet(this, _head, _classPrivateFieldSet(this, _tail, 0));

    _classPrivateFieldGet(this, _free).length = 0;
  } else {
    _classPrivateFieldSet(this, _head, _classPrivateFieldGet(this, _next)[head]);
  }

  _classPrivateFieldGet(this, _keyMap).delete(k);

  _classPrivateFieldSet(this, _size, (_this$size3 = _classPrivateFieldGet(this, _size), _this$size4 = _this$size3--, _this$size3)), _this$size4;
  return head;
}

function _backgroundFetch2(k, index, options, context) {
  var _this4 = this;

  var v = index === undefined ? undefined : _classPrivateFieldGet(this, _valList)[index];

  if (_classPrivateMethodGet(this, _isBackgroundFetch, _isBackgroundFetch2).call(this, v)) {
    return v;
  }

  var ac = new AC();
  var signal = options.signal; // when/if our AC signals, then stop listening to theirs.

  signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function () {
    return ac.abort(signal.reason);
  }, {
    signal: ac.signal
  });
  var fetchOpts = {
    signal: ac.signal,
    options: options,
    context: context
  };

  var cb = function cb(v) {
    var updateCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var aborted = ac.signal.aborted;
    var ignoreAbort = options.ignoreFetchAbort && v !== undefined;

    if (options.status) {
      if (aborted && !updateCache) {
        options.status.fetchAborted = true;
        options.status.fetchError = ac.signal.reason;
        if (ignoreAbort) options.status.fetchAbortIgnored = true;
      } else {
        options.status.fetchResolved = true;
      }
    }

    if (aborted && !ignoreAbort && !updateCache) {
      return fetchFail(ac.signal.reason);
    } // either we didn't abort, and are still here, or we did, and ignored


    var bf = p;

    if (_classPrivateFieldGet(_this4, _valList)[index] === p) {
      if (v === undefined) {
        if (bf.__staleWhileFetching) {
          _classPrivateFieldGet(_this4, _valList)[index] = bf.__staleWhileFetching;
        } else {
          _this4.delete(k);
        }
      } else {
        if (options.status) options.status.fetchUpdated = true;

        _this4.set(k, v, fetchOpts.options);
      }
    }

    return v;
  };

  var eb = function eb(er) {
    if (options.status) {
      options.status.fetchRejected = true;
      options.status.fetchError = er;
    }

    return fetchFail(er);
  };

  var fetchFail = function fetchFail(er) {
    var aborted = ac.signal.aborted;
    var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
    var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
    var noDelete = allowStale || options.noDeleteOnFetchRejection;
    var bf = p;

    if (_classPrivateFieldGet(_this4, _valList)[index] === p) {
      // if we allow stale on fetch rejections, then we need to ensure that
      // the stale value is not removed from the cache when the fetch fails.
      var del = !noDelete || bf.__staleWhileFetching === undefined;

      if (del) {
        _this4.delete(k);
      } else if (!allowStaleAborted) {
        // still replace the *promise* with the stale value,
        // since we are done with the promise at this point.
        // leave it untouched if we're still waiting for an
        // aborted background fetch that hasn't yet returned.
        _classPrivateFieldGet(_this4, _valList)[index] = bf.__staleWhileFetching;
      }
    }

    if (allowStale) {
      if (options.status && bf.__staleWhileFetching !== undefined) {
        options.status.returnedStale = true;
      }

      return bf.__staleWhileFetching;
    } else if (bf.__returned === bf) {
      throw er;
    }
  };

  var pcall = function pcall(res, rej) {
    var _classPrivateFieldGet21;

    var fmp = (_classPrivateFieldGet21 = _classPrivateFieldGet(_this4, _fetchMethod)) === null || _classPrivateFieldGet21 === void 0 ? void 0 : _classPrivateFieldGet21.call(_this4, k, v, fetchOpts);

    if (fmp && fmp instanceof Promise) {
      fmp.then(function (v) {
        return res(v === undefined ? undefined : v);
      }, rej);
    } // ignored, we go until we finish, regardless.
    // defer check until we are actually aborting,
    // so fetchMethod can override.


    ac.signal.addEventListener('abort', function () {
      if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
        res(undefined); // when it eventually resolves, update the cache.

        if (options.allowStaleOnFetchAbort) {
          res = function res(v) {
            return cb(v, true);
          };
        }
      }
    });
  };

  if (options.status) options.status.fetchDispatched = true;
  var p = new Promise(pcall).then(cb, eb);
  var bf = Object.assign(p, {
    __abortController: ac,
    __staleWhileFetching: v,
    __returned: undefined
  });

  if (index === undefined) {
    // internal, don't expose status.
    this.set(k, bf, _objectSpread(_objectSpread({}, fetchOpts.options), {}, {
      status: undefined
    }));
    index = _classPrivateFieldGet(this, _keyMap).get(k);
  } else {
    _classPrivateFieldGet(this, _valList)[index] = bf;
  }

  return bf;
}

function _isBackgroundFetch2(p) {
  if (!_classPrivateFieldGet(this, _hasFetchMethod)) return false;
  var b = p;
  return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof AC;
}

function _connect2(p, n) {
  _classPrivateFieldGet(this, _prev)[n] = p;
  _classPrivateFieldGet(this, _next)[p] = n;
}

function _moveToTail2(index) {
  // if tail already, nothing to do
  // if head, move head to next[index]
  // else
  //   move next[prev[index]] to next[index] (head has no prev)
  //   move prev[next[index]] to prev[index]
  // prev[index] = tail
  // next[tail] = index
  // tail = index
  if (index !== _classPrivateFieldGet(this, _tail)) {
    if (index === _classPrivateFieldGet(this, _head)) {
      _classPrivateFieldSet(this, _head, _classPrivateFieldGet(this, _next)[index]);
    } else {
      _classPrivateMethodGet(this, _connect, _connect2).call(this, _classPrivateFieldGet(this, _prev)[index], _classPrivateFieldGet(this, _next)[index]);
    }

    _classPrivateMethodGet(this, _connect, _connect2).call(this, _classPrivateFieldGet(this, _tail), index);

    _classPrivateFieldSet(this, _tail, index);
  }
}

exports.LRUCache = LRUCache;